import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useIsUserLogged } from '../../context/UserInfoContext';

import PrecisionHotspot from '../PrecisionHotspot';

import MenuIconMobile from '../icons/MenuIcon';

import { useCookie } from '../utils/withCookie';

import styles from './MenuIconMobile.module.scss';

const cx = classNames.bind(styles);

const TT_COOKIE_NAME = 'top-tenant-profile-complete';

const MenuIcon = props => {
  const isUserLogged = useIsUserLogged();
  const menuIconClassname = cx(
    styles.menuIcon,
    styles[props.color],
    props.className
  );

  const { getCookie } = useCookie();
  const hasSeenProfilePage = getCookie(TT_COOKIE_NAME);

  return isUserLogged && props.isTopTenantVariant && !hasSeenProfilePage ? (
    <PrecisionHotspot>
      <button
        type="button"
        className={menuIconClassname}
        onClick={props.onMenuClick}
        data-test="hamburger-menu"
      >
        <MenuIconMobile theme={props.color} className={props.className} />
      </button>
    </PrecisionHotspot>
  ) : (
    <button
      type="button"
      className={menuIconClassname}
      onClick={props.onMenuClick}
      data-test="hamburger-menu"
    >
      <MenuIconMobile theme={props.color} className={props.className} />
    </button>
  );
};

MenuIcon.propTypes = {
  color: PropTypes.oneOf(['dark', 'light']),
  className: PropTypes.string,
  onMenuClick: PropTypes.func,
  isTopTenantVariant: PropTypes.bool,
  isTenantLogged: PropTypes.bool
};

MenuIcon.defaultProps = {
  color: 'dark',
  className: '',
  onMenuClick: () => {},
  isTopTenantVariant: false,
  isTenantLogged: false
};

export default MenuIcon;
